import { HeadTagData } from '@helpers/headTagData';
import {
    getLogoutSsr,
    isUnauthorizedRequest,
} from '@services/identity.service';
import { getOpportunities } from '@services/opportunities.service';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import dynamic from 'next/dynamic';
import OpportunityListingPageSkeleton from '@components/OpportunityListing/components/LoadersAndEmptyStates/OpportunitiesPageSkeleton';

const OpportunityListing = dynamic(
    () => import('@components/OpportunityListing'),
    {
        loading: () => <OpportunityListingPageSkeleton isActiveOpportunities />,
        ssr: false,
    }
);

export default function ActiveOpportunities({
    activities,
    initialFilter,
    isUnlisted,
}) {
    return (
        <>
            <NextHeadTag {...HeadTagData['/opportunities']} />
            <div className="text-left">
                <OpportunityListing
                    fetcher={fetcher}
                    // activities={activities}
                    initialFilter={initialFilter}
                    isUnlisted={isUnlisted}
                    showActiveOpportunities={true}
                />
            </div>
        </>
    );
}

const fetcher = async (params) => {
    return await getOpportunities(params, false);
};

export const getServerSideProps = async (ctx) => {
    try {
        const auth = ctx.req.cookies.AUTH;
        if (!(await isUnauthorizedRequest(auth, ctx))) {
            return {
                redirect: {
                    destination: '/opportunities',
                },
            };
        }

        return {
            props: {
                activities: [],
            },
        };
    } catch (e) {
        return getLogoutSsr(ctx);
    }
};
